<template>
  <div class="product-add">

    <el-form size="small" ref="formData" :model="formData" label-width="200px">

      <el-form-item label="分享文章得积分" prop="share_article_point">
        <el-input type='number' v-model="formData.share_article_point" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="视频奖励设置：">
        <div >
          <el-table
            :data="formData.gradeList"
            border
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="会员等级">
            </el-table-column>
            1
            <el-table-column
              prop="video_type"
              label="奖励类型">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-radio-group  v-model="scope.row.video_type">
                    <el-radio :label="0">固定</el-radio>
                    <el-radio :label="1">随机</el-radio>
                  </el-radio-group>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="video_name"
              label="金额">
              <template v-slot="scope">
                <div class="d-s-c">
                  <span v-if="scope.row.video_type">最高数额</span>
                  <el-input v-model="scope.row.video_value"  min="0"  type="number" placeholder="请输入金额"></el-input>
                  <span class="ml10">元</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="video_limit"
              label="每天数量">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.video_limit" min="0" type="number" placeholder="每天数量"></el-input>
                  <span class="ml10">个</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <el-form-item label="积分转化比例：" prop="money_to_points">
        <el-input v-model="formData.money_to_points" min="0" max="100" type="number"  class="max-w460">
          <template slot="append">
            %
          </template>
        </el-input>
        <div class="tips gray"></div>
      </el-form-item>
      <el-form-item label="视频红包收益限制：" prop="share_user_num">
        <el-input v-model="formData.share_user_num" min="0" type="number"  class="max-w460">
          <template slot="append">
            天
          </template>
        </el-input>
        <div class="tips red">N天内需要直推XX等级或者自己复购XX分类的产品才可以继续领取视频红包收益，填0不限制</div>
      </el-form-item>


      <el-form-item label="视频红包收益条件设置：">
        <div >
          <el-table
            :data="formData.gradeList"
            border
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="会员等级">
            </el-table-column>

            <el-table-column
              prop="invite_grade_id"
              label="直推等级">
              <template v-slot="scope">
                <div class="d-s-c">

                  <el-select v-model="scope.row.invite_grade_id" multiple style="width: 400px;" placeholder="请选择等级">
                    <el-option
                      v-for="item in formData.gradeList"
                      :key="item.grade_id"
                      :label="item.name"
                      :value="item.grade_id">
                    </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="category_id"
              label="复购产品分类">
              <template v-slot="scope">
                <div class="d-s-c">

                  <el-select v-model="scope.row.category_id" multiple style="width: 400px;" placeholder="请选择产品分类">
                    <el-option
                      v-for="item in formData.category"
                      :key="item.category_id"
                      :label="item.name"
                      :value="item.category_id">
                    </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
         <div class="tips gray">直推指定等级才有视频红包收益，不选则不限制直推用户等级</div>
         <div class="tips gray">复购指定产品分类才有红包收益，不选则不限制复购产品的分类</div>
      </el-form-item>
      <!--提交-->
      <div>
        <el-button size="small" type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import ArticleApi from '@/api/article.js';
export default {
  data() {
    return {
      /*form表单数据*/
      formData: {
        share_article_point: 0,
        gradeList:[],
        share_user_num:0,
        money_to_points:0,
        category:[],
      }

    };
  },
  created() {
    this.getData();
  },

  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      ArticleApi.settingDetail({}, true)
        .then(data => {
          if(data.data.values!=[]){
            if (data.data.values.gradeSetting != '' && typeof data.data.values.gradeSetting != 'undefined') {
              let equitys = data.data.values.gradeSetting;
              let pointCondition = data.data.values.pointCondition;
              data.data.gradeList.forEach(item => {
                item.video_type = equitys[item.grade_id]? equitys[item.grade_id].video_type :0;
                item.video_value =equitys[item.grade_id]? equitys[item.grade_id].video_value:0;
                item.video_limit =equitys[item.grade_id]? equitys[item.grade_id].video_limit:0;
                item.invite_grade_id = pointCondition[item.grade_id]? pointCondition[item.grade_id].grade_id:'';
                item.category_id = pointCondition[item.grade_id]? pointCondition[item.grade_id].category_id:'';
              });
            }
            self.formData = data.data.values;
            self.formData.gradeList = data.data.gradeList;
            self.formData.category = data.data.category;

          }

        })
        .catch(error => {});
    },
    /*转JSON字符串*/
    convertJson(list) {
      let obj = {};
      list.forEach(item => {
        obj[item.grade_id] = {
          'video_type':item.video_type,
          'video_value':item.video_value,
          'video_limit':item.video_limit,
        }
      });

      return obj;
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      let params={};
      let gradeSetting={};
      let pointCondition={};
      params.share_article_point = self.formData.share_article_point;
      params.share_user_num = self.formData.share_user_num;
      params.money_to_points = self.formData.money_to_points;

      self.formData.gradeList.forEach(item => {
        gradeSetting[item.grade_id] = {
          'video_type':item.video_type,
          'video_value':item.video_value,
          'video_limit':item.video_limit,
        }
        pointCondition[item.grade_id] = {
          'grade_id':item.invite_grade_id,
          'category_id':item.category_id,
        }
      });
      params.gradeSetting = gradeSetting;
      params.pointCondition = pointCondition;
      // console.log(params);return
      ArticleApi.editSetting(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/article/setting/setting.vue